
export const GLOBAL_CSS_CLASSES = {
	fixedWindow: "fixed-window"
};